var map = {
	"./v-copper.png": "761c",
	"./v-cutter.png": "6a0e",
	"./v-diamond.png": "7cce",
	"./v-king.png": "1a31",
	"./v-metals.png": "f546",
	"./v-silver.png": "ad74",
	"./v1.png": "4b33",
	"./v2.png": "f5b8",
	"./v3.png": "b36e",
	"./v4.png": "6c58",
	"./v5.png": "f318",
	"./v6.png": "93a4",
	"./vip-card.png": "727b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0bcd";